<nav class="tabContent" [ngStyle]="{ 'justify-content': justifyContent() }">
  @for(tab of tabRoutes(); track tab) {
  <a
    class="tab"
    [routerLink]="[$safeNavigationMigration(tab?.route)]"
    routerLinkActive="activeTab"
    [routerLinkActiveOptions]="{ exact: false }"
  >
    @if(tab.icon) {
    <mat-icon>{{ tab?.icon }}</mat-icon>
    }
    <span>{{ tab?.label }}</span>
    @if(tab.badge) {
    <span
      class="tabBadge"
      [attr.title]="tab.badgeLabel"
      [attr.aria-label]="tab.badgeLabel"
      data-testid="tab-badge"
      >{{ tab.badge }}</span
    >
    }
  </a>
  }
</nav>
<div>
  <router-outlet #outlet="outlet"></router-outlet>
</div>
